$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");
        $(".header_sec").removeClass("normalMenu");

    } else {
        $(".header_sec").removeClass("fixed");
        $(".header_sec").addClass("normalMenu");
    }
    
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 150) {
        $(".chats").addClass("actv");

    } else {
        $(".chats").removeClass("actv");
    }
   if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    } 
});


$(document).ready(function () {
    $('.homecaro .owl-carousel').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000,   // total slide time (slow)
        smartSpeed: 2000,        // image fade speed
        dots: false,
        nav: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
    });
});


$(document).ready(function() {
var owl = $('.jobcaro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: true,
    dotsEach: true,
    autoplay: false,
    nav: false,
    loop: true,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 1
      },
      500: {
        items: 2
      },
      700: {
        items: 2
      },
      1000: {
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.testemoni-caro.owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: true,
    dotsEach: true,
    autoplay: false,
    nav: false,
    loop: true,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});



$(document).ready(function() {
var owl = $('.logo-caro.owl-carousel');
  owl.owlCarousel({
    margin:10,
    dots: false,
    autoplay: true,
    slideTransition: 'linear',
    autoplaySpeed: 8000,
    smartSpeed: 8000,
    nav: false,
    slideBy: 1,
    dotsEach: false,
    loop: true,
    navText: [
      '<i class="fa-solid fa-angle-left"></i>',
      '<i class="fa-solid fa-angle-right"></i>'
    ],
    responsive: {
      1: {	
        items: 2
      },
      500: {
        items: 2
      },
      700: {
        items: 3
      },
      1000: {
        items: 4
      },
      1200: {
        items: 5
      },
      1500: {
        items: 6
      }
    }
  });
});


$(document).ready(function () {

    $('.team-caro.owl-carousel').each(function () {

        var $this = $(this);

        if ($this.hasClass('owl-loaded')) return;

        var totalItems = $this.find('.item').length;

        var responsiveConfig = {
            0: { items: 1 },
            500: { items: 2 },
            700: { items: 2 },
            1000: { items: 3 },
            1200: { items: 4 },
            1500: { items: 4 }
        };

        function getItemsCount() {
            var width = $(window).width();
            var items = 1;

            $.each(responsiveConfig, function (breakpoint, config) {
                if (width >= breakpoint) {
                    items = config.items;
                }
            });

            return items;
        }

        var visibleItems = getItemsCount();

        $this.owlCarousel({
            margin: 0,
            dots: false,
            autoplay: true,
            loop: totalItems > visibleItems,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            smartSpeed: 400,
            autoplaySpeed: 400,
            navText: [
                '<i class="fa-solid fa-angle-left"></i>',
                '<i class="fa-solid fa-angle-right"></i>'
            ],
            responsive: responsiveConfig
        });

    });

});
